const storge = {
    /**
     * 设置指定关键字的内容
     * @param groupId 分组编号，可空，用于将键值对分组管理
     */
    set(key, value, groupId = "") {
        return (parent.window || window).storge.set(key, JSON.stringify(value), groupId);
    },
    /**
     *  获取指定关键字的内容
    */
    get(key, groupId = "") {
        let endData = JSON.parse((parent.window || window).storge.get(key, groupId));
        try {
            typeof endData === 'string' && (endData = JSON.parse(endData));
        }
        catch (error) { }
        return endData;
    },
    /**
     * 获取指定分组的键值对列表（已经将value值json化）
     * 输出：[{id,key,value}]
     */
    list(groupId, page = 1, count = 20) {
        return JSON.parse((parent.window || window).storge.list(groupId, page, count));
    },
    /**
     *  移除分组列表返回的指定值
     */
    remove(id) {
        return (parent.window || window).storge.remove(id);
    },
    /**
     *  移除分组列表返回的指定值
    */
    removeKey(key, groupId = "") {
        return storge.set(key, "", groupId);
    },
    localAdd(key, value) {
        return window.localStorage.setItem(key, JSON.stringify(value));
    },
    localGet(key, once = false) {
        const value = window.localStorage.getItem(key);
        once && window.localStorage.removeItem(key);
        return value;
    },
};
export default storge;
